<template>
  <div class="support-page-wrapper position-relative py-5 overflow-hidden">
    <!-- Football Player Graphic for Support Page (Placed at Right Edge of Browser) -->
    <div class="support-player-bg-container d-none d-lg-block">
      <img
        src="https://snippcheck.blob.core.windows.net/files/Danone_US_2008822_Big10GWP/support-player.png"
        alt="Support Football Player"
        class="support-player-edge-img"
      />
    </div>

    <div class="container position-relative z-index-2">
      <!-- Header with Title -->
      <div class="row align-items-center mb-4">
        <div class="col-lg-12 col-md-12 text-center">
          <h1 class="faq-headline">
            {{ $t('Support.SupportTitle') }}
          </h1>
        </div>
      </div>

      <!-- Accordion List -->
      <div class="row faqs mx-auto mb-5">
        <div class="col-12">
          <div class="accordion" id="faqAccordion">
            <div
              class="card"
              v-for="(faq, index) in faqs"
              :key="index"
              :class="{ active: activeIndex === index }"
            >
              <div class="card-header" :id="'heading' + index">
                <h2 class="accordion-header">
                  <button
                    :class="{
                      'arrow-open': activeIndex === index,
                      'arrow-closed': activeIndex !== index,
                    }"
                    class="accordion-button"
                    type="button"
                    @click="toggle(index)"
                    :aria-expanded="activeIndex === index ? 'true' : 'false'"
                    :aria-controls="'collapse' + index"
                  >
                    {{ faq.question }}
                  </button>
                </h2>
              </div>
              <div
                :id="'collapse' + index"
                class="accordion-collapse collapse"
                :class="{ show: activeIndex === index }"
                :aria-labelledby="'heading' + index"
                data-bs-parent="#faqAccordion"
              >
                <div class="card-body" v-html="faq.answer"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FAQ',
  data() {
    return {
      faqs: [],
      activeIndex: null,
      targetFaqKeyword: 'havingTrouble',
    };
  },
  created() {
    this.loadFaqs();
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('havingTrouble')) {
      this.openTargetFaq();
    }

    this.$nextTick(() => {
      const links = this.$el.querySelectorAll('a');
      links.forEach((link) => {
        link.addEventListener('click', () => {
          this.activeIndex = 0;
        });
      });
    });
  },
  watch: {
    '$i18n.locale': 'loadFaqs',
  },
  methods: {
    async loadFaqs() {
      try {
        const currentLocale = this.$i18n.locale;
        const response = await fetch(`/locales/${currentLocale}.json`);
        const data = await response.json();

        if (data && data.Support) {
          this.faqs = data.Support.faqs;
        } else {
          console.error('Invalid FAQ data structure in', currentLocale);
          this.faqs = [];
        }
      } catch (error) {
        console.error('Error loading FAQs:', error);
        this.faqs = [];
      }
    },
    toggle(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
    },
    async openTargetFaq() {
      if (this.faqs.length === 0) {
        await this.loadFaqs();
      }

      const keyword = this.targetFaqKeyword.toLowerCase();
      const targetIndex = this.faqs.findIndex((faq) => {
        return (
          (faq.id && faq.id.toLowerCase() === keyword) ||
          (faq.question && faq.question.toLowerCase().includes(keyword))
        );
      });

      this.activeIndex = targetIndex !== -1 ? targetIndex : 0;

      this.$nextTick(() => {
        const el = document.getElementById(`heading${this.activeIndex}`);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    },
  },
};
</script>

<style scoped>
.support-page-wrapper {
  width: 100%;
  position: relative;
  min-height: 450px;
}

.support-player-bg-container {
  position: absolute;
  right: 0;
  top: 6%;
  z-index: 1;
  pointer-events: none;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
}

.support-player-edge-img {
  max-height: 310px;
  width: auto;
  object-fit: contain;
  opacity: 0.95;
}

.z-index-2 {
  position: relative;
  z-index: 2;
}


</style>
